import { useContext } from 'react';
import { TrackedLink } from 'src/components/TrackedLink';
import styled from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { media } from 'src/styles/designs';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';
import { EventPageHeading } from 'src/modules/events/components/EventPage/EventPageHeading';
import { useTranslate } from 'react-t7e';
import { Button } from 'src/components/common/Button';
import { ChevronRight } from 'src/components/icons/ChevronRight';
import { route } from 'src/services/route';
import { useFlattenEvent } from 'src/modules/events/hooks/useFlattenEvent';
import { useEventRelatedVideosListQuery } from 'src/modules/events/hooks/useEventRelatedVideosListQuery';
import { SliderSectionRender } from 'src/modules/materials/components/ShowcasePage/renderers/SliderSectionRender';

const Section = styled.section`
  padding: 41px 0 20px;
  ${media.w.greaterThanOrEqual.desktop} {
    padding: 64px 0 30px;
  }
`;

const Container = styled(ConstraintContainer)`
  max-width: 1020px;
`;

const VideosContainer = styled.div`
  padding: 30px 0 0;
`;

const ButtonContainer = styled.div`
  margin: 20px 0 0;
`;

export const EventPageRelatedVideosSection = () => {
  const { event } = useContext(EventPageContext);
  const { _ } = useTranslate();

  const flatEvent = useFlattenEvent(event);

  const videos = useEventRelatedVideosListQuery({ event, limit: 10 });

  if (!videos.data || videos.data.length <= 1) {
    return null;
  }

  return (
    <Section>
      <Container>
        <EventPageHeading>
          {_('WATCH HIGHLIGHTS FROM THE EVENT')}
        </EventPageHeading>

        <VideosContainer>
          <SliderSectionRender
            section={{ name: flatEvent.name }}
            event={event}
            items={videos.data}
            header={false}
          />
        </VideosContainer>

        {videos.data.length >= 5 && (
          <ButtonContainer>
            <TrackedLink
              href={{
                pathname: route.event(event).episodes(),
              }}
              passHref
            >
              <Button
                forwardedAs="a"
                icon={ChevronRight}
                iconProps={{ position: 'right' }}
              >
                {_('See all')}
              </Button>
            </TrackedLink>
          </ButtonContainer>
        )}
      </Container>
    </Section>
  );
};
